import { LoadableLazy } from '@confluence/loadable';

export const ViewSpaceExternalCollaboratorsDialogLoadable = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ViewSpaceExternalCollaboratorsDialog" */ './ViewSpaceExternalCollaboratorsDialog'
			)
		).ViewSpaceExternalCollaboratorsDialog,
});
